import { __assign } from '../../../../../../tslib/tslib.es6.js';

var AnnotationTypes;
(function (AnnotationTypes) {
    AnnotationTypes["INLINE_COMMENT"] = "inlineComment";
})(AnnotationTypes || (AnnotationTypes = {}));
var AnnotationMarkStates;
(function (AnnotationMarkStates) {
    AnnotationMarkStates["RESOLVED"] = "resolved";
    AnnotationMarkStates["ACTIVE"] = "active";
})(AnnotationMarkStates || (AnnotationMarkStates = {}));
function buildDataAtributes(_a) {
    var id = _a.id, annotationType = _a.annotationType, state = _a.state;
    var data = {
        'data-mark-type': 'annotation',
        'data-mark-annotation-type': annotationType,
        'data-id': id,
    };
    if (state) {
        return __assign(__assign({}, data), { 'data-mark-annotation-state': state });
    }
    return data;
}
var annotation = {
    inclusive: false,
    group: 'annotation',
    excludes: '',
    attrs: {
        id: {
            default: '',
        },
        annotationType: {
            default: AnnotationTypes.INLINE_COMMENT,
        },
    },
    parseDOM: [
        {
            tag: 'span[data-mark-type="annotation"]',
            skip: true,
        },
    ],
    toDOM: function (node) {
        /*
          Data attributes on the DOM node are a temporary means of
          incrementally switching over to the Annotation mark. Once renderer
          provides native support for inline comments the data attributes on the
          DOM nodes will be removed.
        */
        return [
            'span',
            __assign({ 
                // Prettier will remove the quotes around class. This would cause some browsers
                // to not add this attribute properly, as its a reserved word.
                // prettier-ignore
                'class': 'fabric-editor-annotation' }, buildDataAtributes({
                id: node.attrs.id,
                annotationType: node.attrs.annotationType,
            })),
            0,
        ];
    },
};

export { AnnotationMarkStates, AnnotationTypes, annotation, buildDataAtributes };



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/node_modules/@atlaskit/adf-schema/dist/esm/schema/marks/annotation.js